<div class="newEditionTitle" mat-dialog-title>Nueva edición</div>
<div class="newEditionContent">
  <p>Seleccione fecha de inicio y fin de la edición</p>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10%">

    <mat-form-field fxFlex="50">
      <input matInput [matDatepicker]="editionStartDate" placeholder="Fecha Inicio" (dateChange)="onStartDateChange($event)">
      <mat-datepicker-toggle matSuffix [for]="editionStartDate"></mat-datepicker-toggle>
      <mat-datepicker #editionStartDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field fxFlex="50">
      <input matInput [matDatepicker]="editionEndDate" placeholder="Fecha Final" (dateChange)="onEndDateChange($event)">
      <mat-datepicker-toggle matSuffix [for]="editionEndDate"></mat-datepicker-toggle>
      <mat-datepicker #editionEndDate></mat-datepicker>
    </mat-form-field>

  </div>
  <p>Seleccione fecha y hora de cierre</p>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10%">
    <mat-form-field fxFlex="50">
      <input matInput [matDatepicker]="closeDate" placeholder="Fecha Cierre" (dateChange)="onCloseDateChange($event)">
      <mat-datepicker-toggle matSuffix [for]="closeDate"></mat-datepicker-toggle>
      <mat-datepicker #closeDate></mat-datepicker>
    </mat-form-field>
    <div fxFlex="50" fxLayoutGap="10%" class="hoursMinutes">
      <mat-icon fxFlex="20">schedule</mat-icon>
      <mat-select placeholder="Horas" fxFlex="35" [(value)]="selectedHour">
        <mat-option *ngFor="let hour of hours" [value]="hour">{{hour}}</mat-option>
      </mat-select>
      <mat-select placeholder="Minutos" fxFlex="35" [(value)]="selectedMinute">
        <mat-option *ngFor="let minute of minutes" [value]="minute">{{minute}}</mat-option>
      </mat-select>
    </div>

  </div>

</div>

<div mat-dialog-actions fxLayoutAlign="end start" fxLayoutAlign.lt-sm="center start" class="flexButton">
    <button (click)="saveEdition()" mat-raised-button color="primary" [disabled]="saveDisabled()">
      <mat-icon>save</mat-icon> Guardar</button>
    <a (click)="cancel()" mat-raised-button>
      <mat-icon>cancel</mat-icon> Cancelar</a>
  </div>
